import React from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  InputAdornment,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";
import {
  Add as AddIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
export default function HttpConfigTabs({ card, handleActionCardChange }) {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <Box
      sx={{
        backgroundColor: "white",
        border: "1px solid #D5D8DF",
        borderRadius: "10px",
        overflow: "hidden",
        mb: 2,
      }}
    >
      <Tabs
        value={card.httpTab || 0}
        onChange={(e, newValue) =>
          handleActionCardChange(card.id, "httpTab", newValue)
        }
        sx={{
          minHeight: "56px",
          borderBottom: "0.5px solid #D5D8DF",
          "& .MuiTabs-flexContainer": {
            gap: "4px",
          },
          "& .MuiTab-root": {
            minHeight: "56px",
            textTransform: "none",
            fontSize: "14px",
            fontWeight: 500,
            fontFamily: "Roboto, sans-serif",
            color: "#212121",
            letterSpacing: "0.4px",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            "&.Mui-selected": {
              color: "#2932E5",
            },
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "#2932E5",
            height: "2px",
          },
        }}
      >
        <Tab label="Parameters" />
        <Tab label="Authorization" />
        <Tab label="Headers" />
      </Tabs>

      {/* Parameters Tab */}
      {(card.httpTab === 0 || !card.httpTab) && (
        <>
          <Box
            sx={{
              bgcolor: "white",
              borderBottom: "1px solid white",
              p: "12px 16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                placeholder="Key"
                value={card.httpParamKey || ""}
                onChange={(e) =>
                  handleActionCardChange(
                    card.id,
                    "httpParamKey",
                    e.target.value
                  )
                }
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#e5e7eb",
                    },
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    padding: "16px",
                    color: "#212121",
                    "&::placeholder": {
                      color: "#212121",
                      opacity: 1,
                    },
                  },
                }}
              />
              <TextField
                size="small"
                placeholder="Value"
                value={card.httpParamValue || ""}
                onChange={(e) =>
                  handleActionCardChange(
                    card.id,
                    "httpParamValue",
                    e.target.value
                  )
                }
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#e5e7eb",
                    },
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    padding: "16px",
                    color: "#212121",
                    "&::placeholder": {
                      color: "#212121",
                      opacity: 1,
                    },
                  },
                }}
              />
              <Box
                sx={{
                  backgroundColor: "white",
                  borderRadius: "10px",
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  border: "1px solid #2932E5",
                  "&:hover": {
                    backgroundColor: "#c5c8cf",
                  },
                }}
              >
                <AddIcon
                  sx={{
                    fontSize: 16,
                    color: "#2932E5",
                   
                    // backgroundColor: "white",
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              bgcolor: "white",
              borderBottom: "1px solid white",
              p: "12px 16px",
            }}
          >
            <TextField
              fullWidth
              multiline
              rows={4}
              placeholder="Message Body"
              value={card.messageBody || ""}
              onChange={(e) =>
                handleActionCardChange(card.id, "messageBody", e.target.value)
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                  borderRadius: "10px",
                  "& fieldset": {
                    borderColor: "#e5e7eb",
                  },
                },
                "& .MuiInputBase-input": {
                  fontSize: "14px",
                  fontFamily: "Roboto, sans-serif",
                  // padding: "16px",
                  color: "#212121",
                  "&::placeholder": {
                    color: "#212121",
                    opacity: 1,
                  },
                },
              }}
            />
          </Box>

          <Box
            sx={{
              p: "16px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                // borderColor: "#2932E5",
                borderRadius: "10px",
                textTransform: "none",
                color: "#2932E5",
                px: "14px",
                py: "5px",
                height: "36px",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24.5px",
                border: "1px solid #2932E5",
                // color: "white",
                boxShadow:
                  "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                "&:hover": {
                  

                  backgroundColor: "#c5c8cf",
                },
              }}
            >
              Check Connection
            </Button>
          </Box>
        </>
      )}

      {/* Authorization Tab */}
      {card.httpTab === 1 && (
        <Box
          sx={{
            p: "16px",
          }}
        >
          <Box
            sx={{
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 400,
                color: "#212121",
                mb: 1,
              }}
            >
              Type :
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={card.authType || "No Auth"}
                onChange={(e) =>
                  handleActionCardChange(card.id, "authType", e.target.value)
                }
                sx={{
                  backgroundColor: "white",
                  borderRadius: "10px",
                  fontSize: "14px",
                  fontFamily: "Roboto, sans-serif",
                  "& fieldset": {
                    borderColor: "#e5e7eb",
                  },
                  "& .MuiSelect-select": {
                    padding: "12px 16px",
                  },
                }}
              >
                <MenuItem
                  value="No Auth"
                  sx={{
                    color: "#ff5252",
                    fontFamily: "Roboto, sans-serif",
                  }}
                >
                  No Auth
                </MenuItem>
                <MenuItem
                  value="Basic"
                  sx={{ fontFamily: "Roboto, sans-serif" }}
                >
                  Basic
                </MenuItem>
                <MenuItem
                  value="Digest"
                  sx={{ fontFamily: "Roboto, sans-serif" }}
                >
                  Digest
                </MenuItem>
              </Select>
            </FormControl>
          </Box>

          {card.authType && card.authType !== "No Auth" && (
            <>
              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: 400,
                    color: "#212121",
                    mb: 1,
                  }}
                >
                  Account :
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={card.authAccount || ""}
                  onChange={(e) =>
                    handleActionCardChange(
                      card.id,
                      "authAccount",
                      e.target.value
                    )
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "10px",
                      "& fieldset": {
                        borderColor: "#e5e7eb",
                      },
                    },
                    "& .MuiInputBase-input": {
                      fontSize: "14px",
                      fontFamily: "Roboto, sans-serif",
                      padding: "12px 16px",
                    },
                  }}
                />
              </Box>

              <Box
                sx={{
                  mb: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    fontWeight: 400,
                    color: "#212121",
                    mb: 1,
                  }}
                >
                  Password :
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type={showPassword ? "text" : "password"}
                  value={card.authPassword || ""}
                  onChange={(e) =>
                    handleActionCardChange(
                      card.id,
                      "authPassword",
                      e.target.value
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "10px",
                      "& fieldset": {
                        borderColor: "#e5e7eb",
                      },
                    },
                    "& .MuiInputBase-input": {
                      fontSize: "14px",
                      fontFamily: "Roboto, sans-serif",
                      padding: "12px 16px",
                    },
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      )}

      {/* Headers Tab */}
      {card.httpTab === 2 && (
        <>
          <Box
            sx={{
              bgcolor: "white",
              borderBottom: "1px solid white",
              p: "12px 16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
              }}
            >
              <TextField
                size="small"
                placeholder="Key"
                value={card.httpHeaderKey || ""}
                onChange={(e) =>
                  handleActionCardChange(
                    card.id,
                    "httpHeaderKey",
                    e.target.value
                  )
                }
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#e5e7eb",
                    },
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    padding: "16px",
                    color: "#212121",
                    "&::placeholder": {
                      color: "#212121",
                      opacity: 1,
                    },
                  },
                }}
              />
              <TextField
                size="small"
                placeholder="Value"
                value={card.httpHeaderValue || ""}
                onChange={(e) =>
                  handleActionCardChange(
                    card.id,
                    "httpHeaderValue",
                    e.target.value
                  )
                }
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#e5e7eb",
                    },
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "14px",
                    fontFamily: "Roboto, sans-serif",
                    padding: "16px",
                    color: "#212121",
                    "&::placeholder": {
                      color: "#212121",
                      opacity: 1,
                    },
                  },
                }}
              />
              <Box
                sx={{
                  backgroundColor: "#D5D8DF",
                  borderRadius: "10px",
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#c5c8cf",
                  },
                }}
              >
                <AddIcon
                  sx={{
                    fontSize: 16,
                    color: "#212121",
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              bgcolor: "white",
              borderBottom: "1px solid white",
              p: "12px 16px",
            }}
          >
            <TextField
              fullWidth
              multiline
              rows={4}
              placeholder="Message Body"
              value={card.messageBody || ""}
              onChange={(e) =>
                handleActionCardChange(card.id, "messageBody", e.target.value)
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                  borderRadius: "10px",
                  "& fieldset": {
                    borderColor: "#e5e7eb",
                  },
                },
                "& .MuiInputBase-input": {
                  fontSize: "14px",
                  fontFamily: "Roboto, sans-serif",
                  // padding: "16px",
                  color: "#212121",
                  "&::placeholder": {
                    color: "#212121",
                    opacity: 1,
                  },
                },
              }}
            />
          </Box>

          <Box
            sx={{
              p: "16px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2932E5",
                borderRadius: "10px",
                textTransform: "none",
                px: "14px",
                py: "5px",
                height: "36px",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24.5px",
                color: "white",
                boxShadow:
                  "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                "&:hover": {
                  backgroundColor: "#1f28c7",
                },
              }}
            >
              Check Connection
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
